import type { CityConfig } from "../city-template/types";

export const kirklandConfig: CityConfig = {
  city: "Kirkland",
  state: "Washington",
  stateAbbr: "WA",
  slug: "kirkland",
  route: "/kirkland",
  title: "Emergency Passport Kirkland WA | Expedited Passport Processing | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Kirkland, Washington — as fast as 24 hours. Fast passport renewal and new passport applications for Kirkland, Redmond, Bothell, and all Eastside residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Kirkland, WA",
  heroSubtitle: "Kirkland travelers — from Google campus professionals to Lake Washington waterfront families to Eastside entrepreneurs — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of the Eastside lakefront community and northern King County.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20aerial%20view%20of%20Kirkland%20Washington%20on%20the%20shores%20of%20Lake%20Washington%20with%20Marina%20Park%20and%20downtown%20waterfront%2C%20luxury%20yachts%20and%20sailboats%20on%20the%20lake%2C%20modern%20boutique%20downtown%20with%20tree-lined%20streets%2C%20Spanish-style%20architecture%20mixed%20with%20modern%20buildings%2C%20lush%20evergreen%20surroundings%2C%20warm%20golden%20afternoon%20sunlight%20reflecting%20on%20the%20water%2C%20upscale%20Pacific%20Northwest%20lakefront%20community%20atmosphere%2C%20professional%20city%20photography%20without%20text%20or%20people&width=1800&height=700&seq=kirkland-hero-001&orientation=landscape",
  heroImageAlt: "Kirkland Washington Lake Washington waterfront with Marina Park and downtown",
  geoPosition: "47.6815;-122.2087",
  geoPlacename: "Kirkland, Washington",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Seattle Passport Agency",
    address: "915 2nd Ave Suite 500, Seattle WA 98174",
    distance: "Approximately 12 miles southwest of Kirkland via SR-520",
  },
  nearbyCitiesZips: [
    { name: "Kirkland", zips: "98033, 98034, 98083" },
    { name: "Redmond", zips: "98052, 98053, 98073" },
    { name: "Bellevue", zips: "98004, 98005, 98006, 98007, 98008" },
    { name: "Bothell", zips: "98011, 98012, 98021, 98041" },
    { name: "Woodinville", zips: "98072, 98077" },
    { name: "Kenmore", zips: "98028" },
    { name: "Juanita", zips: "98033, 98034" },
    { name: "Totem Lake", zips: "98034" },
    { name: "Kingsgate", zips: "98034" },
    { name: "Inglewood", zips: "98072" },
    { name: "Lake Forest Park", zips: "98155" },
    { name: "Shoreline", zips: "98133, 98155, 98160, 98177" },
    { name: "Lynnwood", zips: "98036, 98037, 98046, 98087" },
    { name: "Mountlake Terrace", zips: "98043" },
    { name: "Edmonds", zips: "98020, 98026" },
    { name: "Mill Creek", zips: "98012, 98082" },
    { name: "Sammamish", zips: "98074, 98075" },
    { name: "Issaquah", zips: "98027, 98029, 98075" },
    { name: "Mercer Island", zips: "98040" },
    { name: "Clyde Hill", zips: "98004" },
    { name: "Medina", zips: "98039" },
    { name: "Yarrow Point", zips: "98004" },
    { name: "Hunts Point", zips: "98004" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Seattle Passport Agency — just 20 minutes across the lake via SR-520" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-building-line", title: "Google & Eastside Tech Hub", desc: "Serving Google Kirkland campus, tech professionals, and Eastside families" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from any Kirkland or Eastside location" },
  ],
  internalLinks: [
    { name: "Expedited passport in Seattle, WA", route: "/seattle" },
    { name: "Emergency passport help in Bellevue, WA", route: "/bellevue" },
    { name: "Urgent passport services in Redmond, WA", route: "/redmond-wa" },
    { name: "Washington passport services overview", route: "/washington" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Kirkland, Washington remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Seattle Passport Agency (915 2nd Ave Suite 500, Seattle WA 98174) — just 20 minutes across Lake Washington via SR-520. Kirkland residents can ship from any UPS or FedEx on the Eastside.",
  fpcOfficeAddress: "5608 17th Avenue NW, Seattle, WA 98107",
  fpcOfficeDistance: "Serving Kirkland, Redmond, Bothell, Woodinville, Kenmore, Juanita, Totem Lake, Kingsgate, and all of the Eastside Lake Washington communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Kirkland and the Lake Washington Eastside. From the Google campus and downtown Kirkland's waterfront restaurants to the residential neighborhoods of Juanita, Totem Lake, and Kingsgate, from Marina Park to the Woodinville Wine Country — we serve all of Kirkland and the northern Eastside.",
  nearbyCitiesIntro: "We serve Kirkland and all nearby communities including Redmond, Bellevue, Bothell, Woodinville, Kenmore, Juanita, Totem Lake, Kingsgate, Inglewood, Lake Forest Park, Shoreline, Lynnwood, Mountlake Terrace, Edmonds, and Mill Creek. We also serve the Sammamish Plateau and Snohomish County.",
  howItWorksIntro: "Most Kirkland travelers complete everything online and ship documents overnight. No need to drive across the SR-520 bridge to Seattle — our couriers handle the agency delivery and always pick the fastest route.",
  mistakesIntro: "Kirkland is a premier Eastside lakefront community with significant international travel from Google professionals, waterfront families, and entrepreneurs. Here are the most common passport mistakes we see from Kirkland-area travelers.",
  testimonialsIntro: "Kirkland travelers — from Google engineers to waterfront families to Eastside entrepreneurs — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Kirkland, WA? Here are the most common ones we hear from Eastside lakefront travelers.",
  statePageRoute: "/states/washington",
  statePageName: "Washington",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (WA DOH)", url: "https://doh.wa.gov/licenses-permits-and-certificates/vital-records", desc: "Washington State Department of Health — Center for Health Statistics for birth and death certificates statewide" },
    { label: "Marriage Licenses (King County Recorder)", url: "https://www.kingcounty.gov/depts/records-licensing.aspx", desc: "King County Recorder's Office — marriage license applications for Kirkland and Eastside communities" },
    { label: "Divorce Decrees (King County Superior Court)", url: "https://www.kingcounty.gov/courts/superior-court.aspx", desc: "King County Superior Court — divorce decree records for Kirkland and Eastside residents" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Washington birth, death, marriage, and divorce certificates online via VitalChek" },
  ],
  dmvWebsite: "https://www.dol.wa.gov",
  dmvLabel: "Washington DOL — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — close Eastside proximity", "No SR-520 bridge toll or downtown parking hassle", "Perfect for Google and tech travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — close Eastside proximity", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive across Lake Washington to Seattle", "SR-520 bridge toll and downtown parking"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Kirkland travelers with immediate departure needs — as fast as 24 hours. Our couriers handle the Seattle agency delivery. Perfect for Google business travel, luxury vacations, and family emergencies.",
      bullets: ["24–48 hour turnaround available", "Seattle Passport Agency — close Eastside courier", "Google and tech professional travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Kirkland adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Eastside lakefront address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Kirkland residents and families — including Google employees, new citizens, and Eastside families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Kirkland residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Kirkland and Eastside families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Kirkland and Eastside residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Kirkland WA", description: "Urgent passport processing for Kirkland Washington travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Kirkland WA", description: "Fast passport renewal for Kirkland Washington residents with a previously-issued passport." },
    { name: "First-Time Passport Kirkland WA", description: "New passport application services for Kirkland Washington residents applying for their first passport." },
    { name: "Child Passport Kirkland WA", description: "Minor passport services for Kirkland Washington families with children under 16." },
  ],
  testimonials: [
    {
      name: "Priya S.",
      location: "Kirkland, WA",
      rating: 5,
      text: "Google offsite in Zurich with 5 days notice and my passport was expired. Fast Passport Center had my renewed passport in 2 days. I shipped from the UPS Store on Central Way and the whole process was seamless. Outstanding.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "David & Laura K.",
      location: "Juanita, WA",
      rating: 5,
      text: "Family trip to Italy with 8 days notice. Three passports — one adult renewal and two first-time for our kids. Done in 5 days. We shipped from FedEx in Totem Lake and everything was perfect.",
      service: "Family Passport Bundle",
    },
    {
      name: "Rachel W.",
      location: "Kirkland, WA",
      rating: 5,
      text: "Conference in Tokyo with 10 days notice. Fast Passport Center walked me through every step and had my passport in 3 days. The courier service is an absolute game-changer for the Eastside lakefront.",
      service: "Emergency Passport",
    },
    {
      name: "Tom B.",
      location: "Bothell, WA",
      rating: 5,
      text: "Lost my passport the week before a business trip to Singapore. Fast Passport Center replaced it in 48 hours. The proximity to Seattle across SR-520 made the courier service incredibly fast.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "kir-1",
      name: "Kirkland Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11133 120th Ave NE",
      city: "Kirkland",
      state: "WA",
      zip: "98033",
      phone: "(425) 822-5131",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Kirkland, near Totem Lake area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Kirkland acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to Google campus and downtown Kirkland.",
      icon: "ri-mail-line",
    },
    {
      id: "kir-2",
      name: "Redmond Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7241 185th Ave NE",
      city: "Redmond",
      state: "WA",
      zip: "98052",
      phone: "(425) 885-1121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Redmond, approximately 5 miles east of Kirkland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Redmond, Microsoft campus, and east Eastside residents. Ample parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "kir-3",
      name: "Bellevue Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1801 136th Pl NE",
      city: "Bellevue",
      state: "WA",
      zip: "98005",
      phone: "(425) 462-0125",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Bellevue, approximately 7 miles south of Kirkland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Bellevue and south Eastside. Good alternative for southwest Kirkland and Clyde Hill residents.",
      icon: "ri-mail-line",
    },
    {
      id: "kir-4",
      name: "Bothell Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10304 Main St",
      city: "Bothell",
      state: "WA",
      zip: "98011",
      phone: "(425) 483-1552",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Bothell, approximately 6 miles north of Kirkland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Bothell, Kenmore, and north Eastside communities. Good alternative for north Kirkland residents.",
      icon: "ri-mail-line",
    },
    {
      id: "kir-5",
      name: "King County Clerk — Seattle",
      type: "County Clerk Passport Acceptance",
      address: "516 3rd Ave, Room W-105",
      city: "Seattle",
      state: "WA",
      zip: "98104",
      phone: "(206) 477-3080",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Downtown Seattle Courthouse — across the lake via SR-520",
      website: "https://www.kingcounty.com/depts/courts/clerk.aspx",
      websiteLabel: "King County Clerk",
      notes: "County Clerk passport acceptance. Extended hours compared to post office. Kirkland residents may prefer the Kirkland, Redmond, or Bellevue post offices for convenience.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — SR-520 toll bridge to downtown Seattle", fpc: "No — ship from Kirkland" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Lakefront & Tech Advantage", agency: "No special guidance", fpc: "Yes — Eastside tech and luxury travel expertise" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Kirkland Google professionals and waterfront families often discover passport issues just before luxury vacations. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services in downtown Kirkland or at Totem Lake sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at King County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Kirkland Post Office appointments fill during summer and tech conference seasons. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-road-map-line",
      title: "Underestimating SR-520 Bridge Traffic",
      description: "Many Kirkland residents attempt to drive to the Seattle passport agency in an emergency. SR-520 bridge tolls and downtown Seattle parking can add frustration — our courier service is faster and more reliable.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming 4–6 Weeks Is Enough",
      description: "Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service. Summer luxury travel to Europe and tech conference season both peak in the Kirkland area — plan ahead.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in the Kirkland area or Eastside." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Kirkland, Redmond, or Bellevue." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Seattle Passport Agency — no need to cross the SR-520 bridge yourself." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Kirkland address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Kirkland, WA?", a: "Fast Passport Center offers emergency passport processing in Kirkland, Washington in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Seattle Passport Agency (915 2nd Ave Suite 500, Seattle WA 98174) — just 20 minutes across Lake Washington via SR-520." },
    { q: "Does Kirkland have its own passport agency?", a: "No — Kirkland does not have a regional passport agency. The nearest facility is the Seattle Passport Agency (approximately 20 minutes southwest via SR-520). Fast Passport Center's courier service means Kirkland residents never need to deal with bridge tolls and downtown Seattle parking." },
    { q: "Can I get an expedited passport in Redmond, Bothell, or Woodinville?", a: "Absolutely. Fast Passport Center serves all of the northern Eastside including Redmond, Bothell, Woodinville, Kenmore, and the surrounding communities. Our service works the same way everywhere." },
    { q: "What airport do Kirkland travelers use for international flights?", a: "Seattle-Tacoma International Airport (SEA) is the primary airport for Kirkland and the Eastside. SEA is 25–30 minutes via SR-520 or I-405 and offers nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Alaska Airlines and Delta Air Lines are major hubs. Always verify passport validity for at least 6 months past your return date." },
    { q: "Does Fast Passport Center serve Google Kirkland employees?", a: "Yes. Fast Passport Center serves all of the Eastside including Google employees at the Kirkland campus. We understand tech corporate travel schedules and can accommodate urgent international business trips. Our courier service is especially valuable for busy Google professionals who can't take a day off to navigate downtown Seattle." },
    { q: "How much does an expedited passport cost in Kirkland, WA?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Kirkland?", a: "Walgreens, CVS, and Bartell Drugs stores throughout Kirkland and Redmond offer passport photos. UPS Store and FedEx Office locations also provide them. Many locations on Central Way and in the Totem Lake area offer walk-in service. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve the Lake Washington waterfront communities?", a: "Yes. Fast Passport Center serves all Lake Washington communities including Kirkland, Juanita, Yarrow Point, Hunts Point, Clyde Hill, and Medina. We understand the unique needs of Eastside waterfront residents and can accommodate urgent travel for family vacations, business trips, and luxury getaways." },
  ],
  photoLocations: [
    { name: "Walgreens — Central Way", address: "11224 NE 124th St, Kirkland, WA 98034", hours: "Mon–Sun: 7AM–10PM" },
    { name: "Bartell Drugs — Juanita", address: "9826 NE 132nd St, Kirkland, WA 98034", hours: "Mon–Sun: 7AM–10PM" },
    { name: "UPS Store — Totem Lake", address: "12531 120th Ave NE, Kirkland, WA 98034", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Redmond", address: "8867 161st Ave NE, Redmond, WA 98052", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "WA DOL — Kirkland", address: "13131 NE 85th St, Kirkland, WA 98033", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Washington Department of Licensing for driver's licenses, REAL ID, and vehicle registration. Online appointments strongly recommended.", featured: true },
    { name: "WA DOL — Bellevue", address: "13133 NE 20th St, Bellevue, WA 98005", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Serves Bellevue and south Kirkland. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "SEA",
      name: "Seattle-Tacoma International Airport",
      distance: "25–30 minutes from Kirkland via SR-520 or I-405",
      address: "17801 International Blvd, Seattle, WA 98158",
      note: "Primary airport for Kirkland and the Eastside. Nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Alaska Airlines and Delta Air Lines hub. Asia-Pacific gateway with direct flights to Tokyo, Seoul, Beijing, Singapore, and more.",
      flightUrl: "https://www.portseattle.org/sea-tac",
      flightLabel: "SEA Flight Info",
      featured: true,
    },
    {
      code: "BFI",
      name: "King County International Airport (Boeing Field)",
      distance: "Approximately 20 minutes from Kirkland via I-405",
      address: "7277 Perimeter Rd S, Seattle, WA 98108",
      note: "General aviation and cargo airport. Not typically used for international passenger travel. Serves Boeing and corporate aviation.",
      flightUrl: "https://www.kingcounty.gov/depts/transportation/kcia.aspx",
      flightLabel: "BFI Info",
      featured: false,
    },
    {
      code: "PAE",
      name: "Paine Field (Snohomish County)",
      distance: "Approximately 25 minutes north of Kirkland via I-405",
      address: "3220 100th St SW, Everett, WA 98204",
      note: "Commercial flights to select domestic destinations. Alaska Airlines and United serve Paine Field. Alternative to SEA for some domestic travel.",
      flightUrl: "https://www.painefield.com/",
      flightLabel: "PAE Flight Info",
      featured: false,
    },
  ],
};